export default __webpack_public_path__ + "static/media/wind.89b554e8.gif";